import { Routes, Route, RoutesProps } from "react-router-dom";
import React, { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import InvalidAccess from "./InvalidAccess";
const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const LoginV1 = React.lazy(() => import("../components/Login/LoginV1"));
  const ClientSignup = React.lazy(
    () => import("../components/ClientRegistration/ClientSignup")
  );
  const VerifyOtp = React.lazy(
    () => import("../components/ClientRegistration/VerifyOtp")
  );


  const Registration = React.lazy(
    () => import("../components/Login/RegistrationStep1")
  );
  // const RegistrationStep2 = React.lazy(() => import("../components/Login/RegistrationStep2"));
  // const Registration = React.lazy(() => import("../components/Login/Registration"));
  const ForgotPassword = React.lazy(
    () => import("../components/Login/ForgotPassword")
  );
  const Otp = React.lazy(() => import("../components/Login/Otp"));
  const RegisterOtp = React.lazy(
    () => import("../components/Login/RegisterOtp")
  );

  const ResetPassword = React.lazy(
    () => import("../components/Login/ResetPassword")
  );
  const ChangePassword = React.lazy(
    () => import("../components/Login/ChangePassword")
  );

  const WhiteLabelPartners = React.lazy(() => import("../components/WhiteLabelPartners/WhiteLabelPartnerList"));


  const UsersList = React.lazy(() => import("../components/Users/UsersList"));
  const AddUser = React.lazy(() => import("../components/Users/AddUser"));
  const AccessDenied = React.lazy(
    () => import("../components/Common/AccessDenied/AccessDenied")
  );

  const EditUsers = React.lazy(
    () => import("../components/Users/EditUser/EditUserBase")
  );

  const CompanyConsentLanguage = React.lazy(
    () => import("../components/Company/ConsentLanguage")
  );
  const CompanyConsentResponse = React.lazy(
    () => import("../components/Company/ConsentResponse")
  );
  const CompanyContact = React.lazy(
    () => import("../components/Company/Contact")
  );
  const ThirdPartyConsent = React.lazy(
    () => import("../components/Company/ThirdPartyConsent")
  );

  const SuccessSent = React.lazy(() => import("../components/Login/Success"));
  const MyConsents = React.lazy(
    () => import("../components/Consents/MyConsents")
  );

  const AdminRoutes = React.lazy(() => import("../navigation/AdminRoutes"));

  const ClientRoutes = React.lazy(() => import("../navigation/ClientRoutes"));
  const ClientsConsents = React.lazy(
    () => import("../components/Consents/admin/ClientsConsents")
  );

  const EventLogs = React.lazy(
    () => import("../components/EventLogs/EventLogs")
  );

  const CompanyDetails = React.lazy(
    () => import("../components/Company_New/CompanyDetails")
  );
  const Dashboard = React.lazy(
    () => import("../components/Dashboard/Dashboard")
  );
  const DashboardNew = React.lazy(
    () => import("../components/Dashboard/DashboardNew")
  );
  const AccountsDetails = React.lazy(
    () => import("../components/AccountDetails/AccountDetails")
  );
  const ConsentManagment = React.lazy(
    () => import("../components/ConsentManagment/ConsentManagment")
  );
  const ConsentSharing = React.lazy(
    () => import("../components/ConsentSharing/ConsentSharing")
  );
  const EventLog = React.lazy(
    () => import("../components/EventLogs/EventLogs")
  );
  const AIEventLog = React.lazy(
    () => import("../components/EventLogs/AIEventLogs")
  );
  const Support = React.lazy(() => import("../components/Support/Support"));
  const EventLogsAdmin = React.lazy(
    () => import("../components/EventLogsForAdmin/EventLogsForAdmin")
  );
  const AIEventLogsAdmin = React.lazy(
    () => import("../components/EventLogsForAdmin/AIventLogsForAdmin")
  );

  const ConsentSharingAdmin = React.lazy(
    () => import("../components/SuperAdmin/ConsentSharing/ConsentSharing")
  );

  const AddWhiteLabelPartners = React.lazy(
    () => import("../components/SuperAdmin/AccountManagment/AddWhiteLabelPartner"));

  const EditWhiteLabelPartner = React.lazy(
    () => import("../components/SuperAdmin/AccountManagment/EditWhiteLabelPartner"));

  const AddClient = React.lazy(
    () => import("../components/SuperAdmin/AccountManagment/AddClient")
  );
  const EditClient = React.lazy(
    () => import("../components/SuperAdmin/AccountManagment/Editclient")
  );
  const ClientCertificateHistory = React.lazy(
    () => import("../components/Certificates/CertificateList")
  );
  const CertificateHistory = React.lazy(
    () => import("../components/SuperAdmin/Certificates/CertificateList")
  );

  const AIAgentNEW = React.lazy(
    () => import("../components/AIAgentNew/AIAgentNew")
  );

  const AdminDashboard = React.lazy(
    () => import("../components/SuperAdmin/Dashboard/Dashboard")
  );

  const AdminDashboardNew = React.lazy(
    () => import("../components/SuperAdmin/Dashboard/DashboardNew")
  );
  // const RevocationManagment = React.lazy(
  //   () => import("../components/RevocationManagment/RevocationManagment")
  // );
  const ClientLogin = React.lazy(
    () => import("../components/Users/EditUser/ClientLogin")
  );
  const Integration = React.lazy(
    () => import("../components/Integration/Integration")
  );

  let contract_type = localStorage.getItem("contract_type");
  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <LoginV1 />{" "}
              </Suspense>
            }
          />
          <Route
            path="admin/login/:company_id"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <ClientLogin />{" "}
              </Suspense>
            }
          />
          <Route
            path=":partner_id/register"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <ClientSignup />{" "}
              </Suspense>
            }
          />
          <Route
            path=":partner_id/verify-otp"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <VerifyOtp />{" "}
              </Suspense>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <ForgotPassword />{" "}
              </Suspense>
            }
          />
          <Route
            path="/forgot-password/otp"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <Otp />{" "}
              </Suspense>
            }
          />
          <Route
            path="/register/otp"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <RegisterOtp />{" "}
              </Suspense>
            }
          />
          <Route
            path="/reset-password"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <ResetPassword />{" "}
              </Suspense>
            }
          />
          <Route
            path="/success"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <SuccessSent />{" "}
              </Suspense>
            }
          />
          <Route
            path="/access-denied"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <AccessDenied />{" "}
              </Suspense>
            }
          />
          <Route
            path="/change-password"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <ChangePassword />{" "}
              </Suspense>
            }
          />

          {/* All Clients related paths */}

          <Route
            path="/admin"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={
                  <Suspense fallback={<></>}>
                    {/* <LoginV1/> */}
                    <AdminRoutes outlet={<Main />} />{" "}
                  </Suspense>
                }
              />
            }
          >
            <Route
              path="dashboard"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AdminDashboardNew />{" "}
                </Suspense>
              }
            />

            {/* <Route
              path="dashboard"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AdminDashboard />{" "}
                </Suspense>
              }
            /> */}

            <Route
              path="dashboard"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AdminDashboardNew />{" "}
                </Suspense>
              }
            />
            <Route
              path="event-logs"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <EventLogsAdmin />{" "}
                </Suspense>
              }
            />
            <Route
              path="ai-event-logs"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AIEventLogsAdmin />{" "}
                </Suspense>
              }
            />

            <Route
              path="certificate-requests"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <CertificateHistory />{" "}
                </Suspense>
              }
            />

            <Route
              path="consent-sharing"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <ConsentSharingAdmin />{" "}
                </Suspense>
              }
            />

            <Route
              path="clients"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <UsersList />{" "}
                </Suspense>
              }
            />
            <Route
              path="clients/add-client"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AddClient />{" "}
                </Suspense>
              }
            />
            <Route
              path="clients/edit-client/:id"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <EditClient />{" "}
                </Suspense>
              }
            />

            <Route
              path="white-label-partners"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <WhiteLabelPartners />{" "}
                </Suspense>
              }
            />

            <Route
              path="white-label-partners/add"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AddWhiteLabelPartners />{" "}
                </Suspense>
              }
            />

            <Route
              path="white-label-partners/edit/:id"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <EditWhiteLabelPartner />{" "}
                </Suspense>
              }
            />

          </Route>  {/* admin route end */}




          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={
                  <Suspense fallback={<></>}>
                    {/* <LoginV1/> */}
                    <ClientRoutes outlet={<Main />} />{" "}
                  </Suspense>
                }
              />
            }
          >
            {/* <Route
              path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <Dashboard />{" "}
                </Suspense>
              }
            /> 
             */}
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <DashboardNew />{" "}
                </Suspense>
              }
            />
            <Route
              path="/company-details"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <CompanyDetails />{" "}
                </Suspense>
              }
            />
            <Route
              path="/account-details"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AccountsDetails />{" "}
                </Suspense>
              }
            />
            <Route
              path="/consent-management"
              element={
                <Suspense fallback={<></>}>
                  <ConsentManagment />{" "}
                </Suspense>
              }
            />
            <Route
              path="certificate-requested"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <ClientCertificateHistory />{" "}
                </Suspense>
              }
            />
            <Route
              path="ai-agent-new"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AIAgentNEW />{" "}
                </Suspense>
              }
            />

            {/* <Route
              path="/revocation-management"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <RevocationManagment />{" "}
                </Suspense>
              }
            /> */}
            <Route
              path="/consent-sharing"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  {contract_type === "SELF SERVICE" ? (
                    <InvalidAccess />
                  ) : (
                    <ConsentSharing />
                  )}
                </Suspense>
              }
            />
            <Route
              path="/event-logs"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <EventLog />{" "}
                </Suspense>
              }
            />
            {/* <Route
              path="/ai-event-logs"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <AIEventLog />{" "}
                </Suspense>
              }
            /> */}

            <Route
              path="/company/my/consents"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <MyConsents />{" "}
                </Suspense>
              }
            />
            <Route
              path="/company/:slug/contact"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <CompanyContact />{" "}
                </Suspense>
              }
            />
            <Route
              path="/company/consent-language"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <CompanyConsentLanguage />{" "}
                </Suspense>
              }
            />
            <Route
              path="/company/consent-language/response"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <CompanyConsentResponse />{" "}
                </Suspense>
              }
            />
            <Route
              path="/company/third-party/partners"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <ThirdPartyConsent />{" "}
                </Suspense>
              }
            />
            <Route
              path="/integration"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <Integration />{" "}
                </Suspense>
              }
            />
            <Route
              path="/support"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <Support />{" "}
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
